import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 1.00087C8.90451 1.00087 8.79728 1.00087 8.67472 1.00087H4.2002C3.08009 1.00087 2.51962 1.00087 2.0918 1.21886C1.71547 1.41061 1.40974 1.71634 1.21799 2.09267C1 2.52049 1 3.08096 1 4.20107V15.8011C1 16.9212 1 17.481 1.21799 17.9088C1.40974 18.2851 1.71547 18.5914 2.0918 18.7831C2.51921 19.0009 3.07901 19.0009 4.19694 19.0009H11.8031C12.921 19.0009 13.48 19.0009 13.9074 18.7831C14.2837 18.5914 14.5905 18.2851 14.7822 17.9088C15 17.4814 15 16.9224 15 15.8045V7.32656C15 7.20383 15 7.09648 14.9991 7.00087M9 1.00087C9.28564 1.00347 9.46634 1.01385 9.63884 1.05526C9.84292 1.10426 10.0379 1.18527 10.2168 1.29492C10.4186 1.41857 10.5918 1.59182 10.9375 1.9375L14.063 5.06299C14.4089 5.40889 14.5809 5.58136 14.7046 5.7832C14.8142 5.96214 14.8953 6.15726 14.9443 6.36133C14.9857 6.53376 14.9963 6.71451 14.9991 7.00087M9 1.00087V3.8C9 4.92011 9 5.47977 9.21799 5.90759C9.40974 6.28392 9.71547 6.59048 10.0918 6.78223C10.5192 7 11.079 7 12.1969 7H14.9991",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFile;
